import { API, graphqlOperation } from "aws-amplify";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Loader } from "@aws-amplify/ui-react";

import ToolParameterForm from "components/tools/parameters/ToolParameterForm";
import { updateToolParameter } from "graphql/mutations";
import {
  getTool,
  getToolParameter,
  listToolParameters,
} from "graphql/queries";

const ToolParameterUpdateForm = ({
  toolID,
  toolParameterId,
  onSuccess,
}) => {
  const navigate = useNavigate();
  const [toolParameter, setToolParameter] = useState();
  const [companyID, setCompanyID] = useState("");

  async function onSubmit(valuesParam) {
    try {
      const { parameterID, parameterValue } = valuesParam;

      if (toolParameter.parameterID !== parameterID) {
        const oldToolParameterData = await API.graphql(
          graphqlOperation(listToolParameters, {
            filter: {
              and: [
                {
                  toolID: { eq: toolParameter.toolID },
                },
                {
                  parameterID: { eq: parameterID },
                },
              ],
              deletedAt: { attributeExists: false },
            },
          })
        );
        const oldToolParameterItems =
          oldToolParameterData.data.listToolParameters.items;

        if (oldToolParameterItems.length > 0) {
          toast.error(strings.parameterExists);
          return;
        }
      }

      await API.graphql({
        query: updateToolParameter.replaceAll("__typename", ""),
        variables: {
          input: {
            id: toolParameterId,
            parameterID,
            parameterValue,
          },
        },
      });

      toast.success(strings.successUpdated);
      if (onSuccess) onSuccess();
      else navigate("/tools");
    } catch (err) {
      toast.error(strings.responses[err]);
    }
  }

  async function fetchToolParameter(id) {
    try {
      const toolParameterData = await API.graphql(
        graphqlOperation(getToolParameter, { id })
      );
      const toolParameterItem =
        toolParameterData.data.getToolParameter;
      if (!toolParameterItem) {
        toast.error(strings.responses.errorFetch);
        navigate("/tools");
        return;
      }
      setToolParameter({
        ...toolParameterItem,
      });
    } catch (err) {
      toast.error(strings.responses.errorFetch);
    }
  }

  async function getCompanyFromTool(id) {
    try {
      const toolData = await API.graphql(
        graphqlOperation(getTool, { id })
      );
      const toolItem = toolData.data.getTool;
      if (!toolItem) {
        toast.error(strings.responses.errorFetchTool);
        return;
      }
      setCompanyID(toolItem.companyID);
    } catch (err) {
      toast.error(strings.responses.errorFetchTool);
    }
  }

  useEffect(() => {
    fetchToolParameter(toolParameterId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [toolParameterId]);

  useEffect(() => {
    getCompanyFromTool(toolID);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [toolID]);

  if (!toolParameter || !companyID) return <Loader />;

  return (
    <div>
      <ToolParameterForm
        onSubmit={onSubmit}
        type="update"
        initialValues={toolParameter}
        companyID={companyID}
      />
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Actualizar Parámetro de Herramienta",
    successUpdated: "Parámetro de Herramienta actualizado con éxito",
    parameterExists: "El parámetro ya existe en la herramienta",
    responses: {
      errorFetch: "Error al consultar el parámetro de herramienta",
      errorFetchTool: "Error al consultar herramienta",
    },
  },
});

export default ToolParameterUpdateForm;
